export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background: rgb(58 58 87);
          height: '100%';
          min-height: '100%';
        }
        .ReactModal__Body--open {
          overflow: hidden;
        }
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }
        .game-modal-portal-live .ReactModal__Content {
          background: rgb(58 58 87);
        }
      `,
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#218838',
    },
    secondary: {
      main: '#cacaca',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
